

const state = {
  subCompanyList:[] // 分店list
};

const mutations = {
  SET_SUB: (subCompanyList) => {
    state.subCompanyList = subCompanyList
  },
}

export default {
  namespaced: true,
  state,
  mutations,

}
